import { mapGetters } from 'vuex'
import {commmonAjax} from "@/api/common";

export const commonMixin = {
    data() {
        return {
            // 维护一个已知组件的白名单
            validComponents: ['ImageCarouselModule', 'infomationModule', 'quickEntryModule', 'groupModule', 'inlineComponentModule', 'autoNotificationModule', 'thirdLinkModule', 'thirdShowModule', 'globalSuspendedWindow', 'middleBackgroundModule']
        }
    },
    computed: {
        // 或者使用 getters
        ...mapGetters('template', [
            'templateData',
            'getModuleByCode'
        ]),
        moduleComponentList() {
            // console.log(this.templateData, 'templateDatatemplateData')
            // return this.templateData?.resultData?.moduleComponentList.filter(item => !item.moduleCode.includes['headerBackground', 'headerInformation', 'middleBackground','bottom']) || [];
            const excludeCodes = ['headerbackground', 'headerinformation', 'middlebackground', 'bottom', 'desktopNavModule'];

            return this.templateData?.resultData?.moduleComponentList.filter(item => {
                // 转换为小写进行比较
                return !excludeCodes.includes(item.moduleCode?.toLowerCase());
            }) || [];
        },

        globalModuleList() {
            // console.log(this.templateData, 'templateDatatemplateData')
            // return this.templateData?.resultData?.moduleComponentList.filter(item => !item.moduleCode.includes['headerBackground', 'headerInformation', 'middleBackground','bottom']) || [];
            const excludeCodes = ['headerbackground', 'headerinformation', 'desktopnavmodule'];
            return this.templateData?.resultData?.moduleComponentList.filter(item => {
                // 转换为小写进行比较
                return excludeCodes.includes(item.moduleCode?.toLowerCase());
            }) || [];
        },

        // 按 orderId 排序的模块列表
        sortedModuleComponentList() {
            return [...this.moduleComponentList].sort((a, b) => {
                return (a.orderId || 0) - (b.orderId || 0);
            });
        },

        // 获取模块属性
        moduleAttribute() {
            if (this.moduleData && this.moduleData.moduleStyleData) {
                try {
                    return JSON.parse(this.moduleData.moduleStyleData);
                } catch (e) {
                    console.error('Failed to parse moduleStyleData', e);
                    return {};
                }
            }
            return {};
        }
    },
    methods: {
        /**
         * 根据 moduleCode 获取组件名称
         */
        getComponentName(moduleCode) {
            // 直接匹配已注册的组件名称
            if (['ImageCarouselModule', 'desktopNavModule', 'infomationModule', 'autoNotificationModule', 'quickEntryModule', 'groupModule', 'infomationModule', 'thirdLinkModule', 'globalSuspendedWindow', 'middleBackgroundModule'].includes(moduleCode)) {
                return moduleCode;
            }

            // 映射关系 - 根据实际数据结构调整
            const nameMap = {
                'groupModule': 'groupModule',
                'HEADER_INFORMATION': 'desktopNavModule',
                'HEADER_BACKGROUND': 'ImageCarouselModule',
                'BOTTOM': 'InfomationModule',
                'AUTO_NOTIFICATION': 'autoNotificationModule',
                'PartyBuildingColumn': 'InfomationModule'
            };

            return nameMap[moduleCode] || moduleCode;
        },

        getComponListAttribute(componentList,type) {
            if (type) {
                console.log(componentList, 'componentListcomponentList3')
            }
            if (componentList) {
                try {
                    return componentList.map(item => {
                        // 直接创建新对象而不是深拷贝整个数组
                        return {
                            ...item,
                            componentAttr: item.styleData ? JSON.parse(item.styleData).componentData[0] : {}
                        };
                    });
                } catch (e) {
                    console.error('Failed to parse moduleStyleData', componentList);
                    return [];
                }
            }
            return [];
        },

        commonAjaxMethods(url, query = {}, methods = 'get') {
            let apiUrl = url.split('?')[0]
            let urlQuery = url.split('?')[1] || ''
            let apiQuery = new URLSearchParams(urlQuery);
            console.log(apiQuery,urlQuery, 'urlQuery', 'apiQueryapiQuery')
            let obj = {};

            for (let param of apiQuery.entries()) {
                console.log(param, 'paramparamparam')
                obj[param[0]] = param[1];
            }
            let params = {
                url: apiUrl,
                query: {...obj, ...query},
                methods
            }
            console.log(params, 'pripairpi')
            return commmonAjax(params)
        }
    }
}
